import React from 'react'
import Popup from '../popup/Popup'
import SingleFrame from '../singleFrame/SingleFrame'
import { kidDisplayTotals } from '../../service/familyPlanUtil'


export default function ChildRowPopup({ kid, closePopup }) {
    const totals = kidDisplayTotals(kid)
    return (
        <Popup  closePopup={closePopup} >
            <div className="title-wrapper">
                <h3>סיכום תרומה והלוואה</h3>
                <p className='sub-header'>לכל גיל מסלול שונה, אנא בחרו את המסלול המתאים לכם</p>
            </div>
            <div className='child-row-popup'>
                <SingleFrame label={'שם הילד/ה'} value={kid?.name} />
                <SingleFrame label={'תעודת זהות'} value={kid?.personId} />
                <SingleFrame label={'תאריך לידה'} value={(kid?.preBorn) ? 'טרום לידה' : kid?.birthday} />
                <SingleFrame label={'מסלול/תוכנית'} value={kid?.plan?.title} />
                <SingleFrame label={'כמות יחידות'} value={totals.units} />
                <SingleFrame label={'תרומה חודשית'} value={totals.monthlyDonation} currency={true} />
                <SingleFrame label={'תשלומים'} value={totals.payments} />
                <SingleFrame label={'סה"כ תרומה'} value={totals.totalDonation} currency={true} />
                <SingleFrame label={'החזר חודשי'} value={totals.monthlyReturn} currency={true} />
                <SingleFrame label={'תשלומים'} value={totals.returnPayments} />
                <SingleFrame label={'סה"כ הלוואה'} value={totals.totalLoan} currency={true} />
                <SingleFrame label={'מענק'} value={totals.grant} currency={true} />

            </div>
        </Popup>
    )
}
